import { useEffect, useState } from 'react';
import './Header.scss';
import Button from '../shared/Button'
import Modal from '../shared/Modal'

const Header = () => {
    const [isModalOpen, setIsModalOpen] = useState(true)

    return (
        <>
            <div className={`header-container`}>
                <div className={`header-content`}>
                    <span>JúliaSoaresNajjar.</span>
                    <Button onClick={() => setIsModalOpen(true)}>?</Button>
                </div>
            </div>
            <Modal open={isModalOpen}>
                <div className='modal-intro-header'>
                </div>
                <div className='modal-intro-page'>
                    <span>Oi! Júlia está chegando 🎉 Por isso, criamos esse site com muito amor para celebrar esse momento.</span>
                    <span>Nele, você vai encontrar diferentes opções de presentes e levar para a Jujuba no dia do nosso chá de bebê! É super fácil de navegar e escolher.</span>
                    <span>Ao selecionar o mimo, você também pode deixar o seu nome e uma mensagem para a nossa pequena. 🐼 Vamos guardar com carinho para que ela possa ler no futuro. 🩷</span>
                    <span className='bold'>Ah! E não se preocupe: todas as imagens dos produtos são meramente ilustrativas. A ideia do site é evitar duplicidade de presentes e elencar as coisinhas que mais estamos precisando neste momento.</span>
                    <Button onClick={() => {setIsModalOpen(false)}}>Ok!</Button>
                </div>
            </Modal>
        </>
    )
}

export default Header;